import { createEventBus } from "../Common/eventBusFactory";

export const eventBus = createEventBus();

export const OPEN_ADD_PRICING_MODAL = "onOpenAddPricingModal";
export const OPEN_CONFIGURE_PAYMENT_GATEWAY_MODAL = "onOpenConfigurePaymentGatewayModal";
export const OPEN_EDIT_PRICING_MODAL = "onOpenEditPricingModal";
